import React, { useState } from 'react'
//Helpers
import flecha from './flecha.svg'
import axios from 'axios'
import ReCAPTCHA from 'react-google-recaptcha'
import image1 from './image1.jpg'
import image2 from './image2.jpg'
import image3 from './image3.jpg'
import Slider from 'react-slick'

import LogoFlamma from './logo_flamma.svg'
import { RealEstateDataPageComponentData } from 'types'
import { useDispatch } from 'react-redux'
import { useCreateFormMutation as useSendContactFormMutationLanding } from '@apis/mediacore/contact'

const settings = {
  autoplay: true,
  dots: false,
  infinite: true,
  speed: 5000,
  items: 3,
  fade: true,
  slidesToShow: 1,
}

const isBrowser = typeof window !== 'undefined'

const LandingPerfo = ({ global_data }: RealEstateDataPageComponentData) => {
  //function current year
  const getCurrentYear = () => {
    const currentYear = new Date().getFullYear()
    return currentYear
  }

  return (
    isBrowser && (
      <section
        className="perfo-landing a"
        id=""
      >
        <div className="d-flex">
          <Slider
            {...settings}
            lazyLoad="ondemand"
            className="overflow-hidden"
          >
            <img
              style={{ height: '100vh' }}
              src={image1}
              alt=""
            />
            <img
              style={{ height: '100vh' }}
              src={image2}
              alt=""
            />
            <img
              style={{ height: '100vh' }}
              src={image3}
              alt=""
            />
          </Slider>
          <div className="container-fluid">
            <div
              className="row align-items-center"
              id="main-section"
            >
              <div className="col-12">
                <div className="row align-items-center justify-content-between">
                  <LandingText />
                  <ContactForm global_data={global_data} />
                  {/* <LogosMobile /> */}
                  {/* <div className="d-flex w-100 text-center justify-content-center">
                        </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <footer
          className="mt-3 mt-lg-0 "
          style={{ textAlign: 'center' }}
        >
          <p
            style={{ color: '#fff' }}
            className="copy"
          >
            Promoted by{' '}
            <a
              target="_blank"
              className="normal-color"
              href="https://mediahaus.com.ar"
            >
              {' '}
              MediaHaus
            </a>{' '}
            - Powered by{' '}
            <a
              target="_blank"
              className="white"
              href="https://mediacore.app/"
              style={{ color: '#fff' }}
            >
              {' '}
              MediaCore
            </a>
            <br />
            <span className="small-text">Todos los derechos reservados ® {getCurrentYear()}</span>
          </p>
        </footer>
      </section>
    )
  )
}

const LandingText = () => {
  return (
    <div className="col-lg-6">
      <div
        id="flag-section"
        className="d-flex flex-column"
      >
        <img
          src={LogoFlamma}
          className="LogoFlamma"
          alt="Flamma"
        />

        <h2
          style={{
            textTransform: 'uppercase',
            fontWeight: '600',
            display: 'inline-block',
            margin: '.5rem 0 1rem 0',
            color: '#B5AA79',
            lineHeight: '1.2',
          }}
        >
          ¿BUSCÁS UNA FORMA INTELIGENTE DE VENDER TU TERRENO O CASA?
        </h2>

        {/* <h3 className="txtmin ">EN DEVOTO</h3>  */}
        {/* {<h3 className="txtmin ">OPORTUNIDAD HOY DESDE</h3>} */}

        {/* <h2 className="d-none d-lg-block " style={{textTransform: 'uppercase',fontWeight:'400',display:'inline-block', margin: '1rem 0 1rem 0', color: '#fff'}}>DESDE <span style={{fontWeight:'600',fontSize:'3.6rem'}}>1.050 USD</span> EL M2</h2> 
          <h2 className="d-block d-lg-none" style={{textTransform: 'uppercase',fontWeight:'400',display:'inline-block', margin: '2rem 0 1rem 0', color: '#fff'}}>DESDE <span style={{fontWeight:'600',fontSize:'3.6rem'}}><br />1.050 USD</span><br /> EL M2</h2>  */}
      </div>

      <div className="feature-wrap">
        <div className="d-flex flex-column align-items-center align-items-lg-start">
          <h4 className="d-flex align-items-start">
            <img
              src={flecha}
              className="flecha"
              alt="flecha"
              style={{ marginTop: '.5rem' }}
            />
            Transformá tu propiedad en departamentos premium ubicados en la mejor zona de Devoto.
          </h4>
        </div>
        <div className="d-flex flex-column align-items-center align-items-lg-start">
          <h4 className="d-flex align-items-center">
            <img
              src={flecha}
              className="flecha"
              alt="flecha"
            />
            Desarrollamos proyectos exclusivos que se adaptan a tus necesidades.
          </h4>
        </div>
        <div className="d-flex flex-column align-items-center align-items-lg-start">
          <h4 className="d-flex align-items-start">
            <img
              src={flecha}
              className="flecha"
              alt="flecha"
              style={{ marginTop: '.5rem' }}
            />
            Tomamos tu terreno o casa como forma de pago.
          </h4>
        </div>
        <div className="d-flex flex-column align-items-center align-items-lg-start">
          <h4 className="d-flex align-items-start">
            <img
              src={flecha}
              className="flecha"
              alt="flecha"
              style={{ marginTop: '.5rem' }}
            />
            Te ofrecemos la mejor solución.
          </h4>
        </div>
        <div className="d-flex flex-column align-items-center align-items-lg-start">
          <h4 className="d-flex align-items-center">
            <img
              src={flecha}
              className="flecha"
              alt="flecha"
            />
            Hacé tu mejor inversión.
          </h4>
        </div>
      </div>

      <h2
        style={{
          textTransform: 'uppercase',
          fontWeight: '600',
          display: 'inline-block',
          margin: '.5rem 0 1rem 0',
          color: '#B5AA79',
          lineHeight: '1.2',
        }}
      >
        ACTIVÁ EL VALOR DE TU CAPITAL
      </h2>
    </div>
  )
}

const ContactForm = ({ global_data }: RealEstateDataPageComponentData) => {
  const [submitted, setSubmitted] = useState(false)
  const [disabled, setDisabled] = useState(true)

  const [sendContactForm] = useSendContactFormMutationLanding()

  const dispatch = useDispatch()

  const { captcha, tokko: tokkoKey } = global_data.pageConfig.keys
  // const GAEventsTracker = useGAEventTracker("PPC");

  const [inputValue, setInputValue] = useState({
    nombre: '',
    email: '',
    telefono: '',
    comentario: '',
  })

  const handleChange = (event: any) => {
    setInputValue({ ...inputValue, [event.target.name]: event.target.value })
  }

  // const getUtm = () => {
  //   var queryString = window.location.search
  //   var urlParams = new URLSearchParams(queryString)
  //   return urlParams.get('utm_source') || ''
  // }

  const getUtm = () => {
    if (typeof window !== 'undefined') {
      var queryString = window.location.search
      var urlParams = new URLSearchParams(queryString)
      const tags = []
      for (const [key, value] of urlParams) {
        if (key.includes('source')) {
          tags.push('Origen: ' + value)
        }
        if (key.includes('medium')) {
          tags.push('Pieza: ' + value)
        }
        if (key.includes('campaign')) {
          tags.push('Campaña: ' + value)
        }
      }
      return tags
    }
    return []
  }

  const handleSubmit = (event: any) => {
    let tags = ['Terrenos Flamma']
    for (const iterator of getUtm()) {
      tags.push(iterator)
    }

    formTokko(tags, inputValue)
    event.preventDefault()
    setSubmitted(true)
    // GAEventsTracker("Lead",1)
  }

  const formTokko = (
    tags: string[],
    fields: { nombre: string; email: string; comentario: string; telefono: string },
  ) => {
    // Campos del formulario.
    let body = ''
    var name = ''
    //Armo el texto del formulario.
    if (fields.nombre) {
      name += fields.nombre
    }
    if (fields.telefono) {
      body += 'Telefono: ' + fields.telefono + '\n'
    }
    body += 'Email: ' + fields.email + '\n '
    if (fields.comentario) {
      body += 'Mensaje: ' + fields.comentario + '\n '
    }

    //Agrego tags.
    var curTags = []
    tags.map((tag) => {
      curTags.push(tag)
    })

    //Armo todo el objeto a enviar
    var message = JSON.stringify({
      name,
      email: fields.email,
      tags,
      text: body,
    })
    sendContactForm({
      data: {
        name: name,
        email: fields.email,
        phone: fields.telefono,
        message: body,
        property_id: '',
      },
      type: 'landing',
      site: global_data.id,
    })
    axios.post('https://tokkobroker.com/api/v1/webcontact/?key=' + tokkoKey + '', message, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
  }

  return (
    <div className="col-lg-4 text-center">
      <div className="row justify-content-end">
        <div
          id="response"
          className="col-lg-11"
        ></div>
        <div
          className="col-lg-11 p-4 p-lg-5"
          id="contact-column"
        >
          <div className="form">
            {/* <img src="img/logo_campos.svg" /> */}
            {!submitted ? (
              <>
                <div className="header-wrapper">
                  <h5>
                    Contactate con nosotros <br />
                    para recibir más información
                  </h5>
                  {/* <img src={FormLogo} className="form-logo" alt="Pareja 3645" /> */}
                </div>
                <form
                  onSubmit={handleSubmit}
                  id="contacto"
                  className="mt-4"
                >
                  <input
                    className="mb-lg-3 mb-3"
                    type="text"
                    onChange={handleChange}
                    name="nombre"
                    placeholder="Nombre completo"
                  />
                  <input
                    className="mb-lg-3 mb-3"
                    type="email"
                    onChange={handleChange}
                    name="email"
                    placeholder="Email *"
                    required
                  />
                  <input
                    className="mb-lg-3 mb-3"
                    type="text"
                    onChange={handleChange}
                    name="telefono"
                    placeholder="Teléfono"
                  />
                  {/* <input  type="text" onChange={handleChange}  name="comentario" placeholder="Comentarios" /> */}
                  <textarea
                    onChange={handleChange}
                    className="mb-lg-3 mb-3"
                    name="comentario"
                    placeholder="Comentarios"
                    id=""
                    cols={20}
                    rows={5}
                  ></textarea>
                  {/* <!-- <button className="mt-3" type="submit">INVERTÍ AHORA</button> --> */}
                  <div className="d-flex flex-column align-items-center">
                    {/* <ReCAPTCHA
                            sitekey="6Lel-rodAAAAAH3vs9192XBf4sd_bSWNAjtqUX53"
                            onChange={() => setDisabled(false)}
                        /> */}
                    {captcha ? (
                      <ReCAPTCHA
                        sitekey={captcha}
                        onChange={() => setDisabled(false)}
                      />
                    ) : (
                      ''
                    )}
                    <input
                      type="submit"
                      value="CONTACTANOS"
                      className="btn mt-4"
                      disabled={disabled}
                      id="submit-info"
                    />
                    {/* disabled={disabled}  */}
                  </div>
                </form>
              </>
            ) : (
              <>
                {/* {getScript()} */}
                <h5 className="mb-5">
                  ¡Gracias por su consulta!
                  <br /> en menos de 24hs
                  <br /> te responderemos.
                </h5>
                <a
                  onClick={() => setSubmitted(false)}
                  className="btn btn-link"
                >
                  ENVIAR OTRA CONSULTA
                </a>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default LandingPerfo
